import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AmorphicService } from '../services/amorphic/amorphic.service';
import { AccountCenterService } from '../services/account-center/account-center.service';
import { UICategory, UILoggerSingleton } from '../../../common/js/logger/UILoggerSingleton';

@Injectable()
export class IndividualApplicationAccessGuard implements CanActivate {
  constructor(
    private router: Router,
    private amorphicService: AmorphicService,
    private accountCenterService: AccountCenterService
  ) {}

  canActivate(activatedRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const applicationsForCustomer = this.amorphicService.controller.customer.activeApplications;
    const requestedApplicationNumber = activatedRoute.queryParamMap.get('applicationNumber');

    const matchingApplication = this.accountCenterService.getApplicationWithNumber(
      applicationsForCustomer,
      requestedApplicationNumber
    );

    if (matchingApplication) {
      return true;
    } else {
      UILoggerSingleton.getInstance().warn(
        {
          module: 'IndividualApplicationAccessGuard',
          function: 'canActivate',
          category: UICategory.request,
          data: {
            requestedApplicationNumber,
          },
        },
        'Rerouting to account center overview due to unknown applicationNumber'
      );

      this.router.navigate(['account-center']);
      return false;
    }
  }
}
